<template>
  <span class="text-hide-by-line ellipsis" ref="textHide" :style="{
    lineClamp: showAll ? contentLine + 2 : maxLine,
    background: bgColor,
  }">
    <span class="text-hide-by-line text-hide-by-line-fixed" ref="textFixed" v-if="contentLine === 0">
      <slot></slot>
      <text-highlight :val="content" :highlight-key="highlightKey" :color="color"/>
      <span class="full-text" style="position: relative">全文</span>
    </span>
    <slot></slot>
    <text-highlight :val="content" :highlight-key="highlightKey" :color="color"/>
    <span
        class="full-text"
        :style="{
          background: bgColor,
          position: showAll ? 'relative' : 'absolute',
        }"
        @click.stop="showAll = !showAll"
        v-show="contentLine > maxLine"
        v-if="!hideBtn && btnType === 'text'"
    >
      {{ showAll ? '收起' : '全文' }}
    </span>
    <span
        class="full-text-icon"
        :style="{
          background: bgColor,
          width: fontSize + 'px',
          height: fontSize + 'px',
        }"
        @click.stop="showAll = !showAll"
        v-show="contentLine > maxLine"
        v-if="!hideBtn && btnType === 'icon'"
    >
      <img src="../assets/icon-152.png" alt="" v-if="showAll">
      <img src="../assets/icon-151.png" alt="" v-else>
    </span>
  </span>
</template>

<script>

import TextHighlight from "@/components/text-highlight.vue";
import {getStringByMaxSize, getStringSize} from "@/common/util";
import TextHide from "@/components/text-hide.vue";

export default {
  name: 'text-hide-by-line',
  components: {TextHide, TextHighlight},
  props: {
    val: {
      default: '',
    },
    maxLine: {
      default: 2,
    },
    hideBtn: {
      default: false,
    },
    bgColor: {
      default: '#FFFFFF'
    },
    btnType: {
      default: 'text',
    },
    highlightKey: {
      default: '',
    },
    color: {
      default: '#FF6700',
    },
  },
  data() {
    return {
      showAll: false,
      contentLine: 0,
      fontSize: 0,
    };
  },
  computed: {
    valSize() {
      return getStringSize(this.val);
    },
    content() {
      const maxSize = this.maxSize;
      let val = this.val;
      if (!this.showAll && this.valSize > maxSize && maxSize > 0) {
        val = getStringByMaxSize(val, maxSize) + '...';
      }
      return val;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.heightChangeEvent();
    });
  },
  methods: {
    heightChangeEvent(item) {
      const content = this.$refs.textHide;
      // resize后的处理逻辑
      const contentResizeObserver = new ResizeObserver(() => {
        this.contentLine = 0;
        if (!!this.$refs.textHide) {
          this.fontSize = parseFloat(window.getComputedStyle(this.$refs.textHide).fontSize);
        }
        this.$nextTick(() => {
          if (this.contentLine === 0 && !!this.$refs.textFixed) {
            const textFixedWidth = parseFloat(this.$refs.textFixed.offsetWidth);
            const textHideWidth = parseFloat(this.$refs.textHide.offsetWidth);
            this.contentLine = Math.ceil(textFixedWidth / textHideWidth);
          }
        });
      }); // 创建一个observer实例
      contentResizeObserver.observe(content);
    },
  },
}
</script>

<style scoped>
.text-hide-by-line {
  position: relative;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  /*-webkit-line-clamp: 2;*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.full-text {
  color: #2A63F3;
  position: absolute;
  padding: 0 5px;
  right: 0;
  bottom: 0;
}

.text-hide-by-line-fixed {
  display: block;
  white-space: nowrap;
  position: fixed;
  left: -200vw;
  top: -100vh;
}

.text-hide-by-line-fixed * {
  display: inline-block;
}

.full-text-icon{
  position: absolute;
  padding: 0 5px;
  right: 0;
  bottom: 0;
  display: inline-block;
  align-items: center;
}

.full-text-icon img{
  width: 120%;
  display: block;
  position: relative;
  transform: translateX(-10%) translateY(-20%);
}
</style>
